import { useAuth } from 'context/AuthProvider.js';
import { httpClient } from 'helpers/HttpClient.js';
import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Form, FormControl, Row } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { ApiEndpoint } from 'helpers/ApiEndPoint.js';
import PropTypes from 'prop-types';
import NotificationAlert from 'componentes/generic/Notification.js';
import AutocompleteDropdown from 'componentes/generic/AutoComplete.js';
const URI = ApiEndpoint + 'administration/';
const URIConfig = ApiEndpoint + 'configuration/';

const EditAdress = ({ idAddress, idCustomer, closeModal }) => {
  const Auth = useAuth();
  var userData = Auth.getSessionData();
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [errorMesagge, setErrorMesagge] = useState(null);
  const [isError, setIsError] = useState(true);
  const [selectedEstado, setSelectedEstado] = useState(null);
  const [municipios, setMunicipios] = useState(null);
  const [cps, setCps] = useState(null);
  const [selectedMunicipioDescription, setSelectedMunicipioDescription] =
    useState(null);
  const [selectedCodigoPostalDescription, setSelectedCodigoPostalDescription] =
    useState(null);
  const [states, setStates] = useState(null);
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors }
  } = useForm();
  const [customer, setCustomer] = useState({
    calle: '',
    noint: '',
    noext: '',
    colonia: '',
    idcodigopostal: ''
  });
  const getStatesList = async () => {
    setStates(null);

    httpClient('GET', URIConfig + 'states', {}, userData.token)
      .then(function (response) {
        if (!response.data.error) {
          setStates(response.data);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const getMunicipiosList = async idState => {
    setMunicipios(null);

    httpClient('GET', URIConfig + 'cities/' + idState, {}, userData.token)
      .then(function (response) {
        if (!response.data.error) {
          setMunicipios(response.data);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const getCpsList = async idMunicipio => {
    setCps(null);

    httpClient(
      'GET',
      URIConfig + 'codigospostalesbymunicipio/' + idMunicipio,
      {},
      userData.token
    )
      .then(function (response) {
        if (!response.data.error) {
          setCps(response.data);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  const getAddress = async () => {
    setCustomer(null);

    httpClient('GET', URI + 'address/' + idAddress, {}, userData.token)
      .then(function (response) {
        if (!response.data.error) {
          setValue('calle', response.data.calle);
          setValue('noint', response.data.noint);
          setValue('noext', response.data.noext);
          setValue('colonia', response.data.colonia);
          setValue('idcodigopostal', response.data.idcodigopostal);
        }
        return response.data.idcodigopostal;
      })
      .then(function (idCp) {
        httpClient(
          'GET',
          URIConfig + 'codigopostal/' + idCp,
          {},
          userData.token
        ).then(function (response) {
          getMunicipiosList(response.data.municipio.idestado);
          setSelectedEstado(response.data.municipio.idestado);
          setSelectedMunicipioDescription(response.data.municipio.descripcion);
          getCpsList(response.data.idmunicipio);
          setSelectedCodigoPostalDescription(response.data.codigopostal);
        });
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(() => {});
  };
  useEffect(() => {
    if (idAddress > 0) getAddress();
    getStatesList();
  }, []);
  const onSubmit = data => {
    console.log(data);

    if (idAddress > 0) {
      httpClient(
        'put',
        URI + 'address/' + idAddress,
        {
          calle: data.calle,
          noint: data.noint,
          noext: data.noext,
          colonia: data.colonia,
          idcodigopostal: data.idcodigopostal.id
        },
        userData.token
      )
        .then(function (response) {
          if (!response.data.error) {
            closeModal();
          } else {
            setErrorMesagge(response.data.message);
            setShowErrorMessage(true);
          }
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(() => {});
    } else {
      httpClient(
        'POST',
        URI + 'addresscustomer',
        {
          calle: data.calle,
          noint: data.noint,
          noext: data.noext,
          colonia: data.colonia,
          idcodigopostal: data.idcodigopostal.id,
          idcliente: idCustomer
        },
        userData.token
      )
        .then(function (response) {
          if (!response.data.error) {
            setIsError(false);
            setErrorMesagge('Registro Creado Exitosamente');
            setShowErrorMessage(true);
            closeModal();
          } else {
            setErrorMesagge(response.data.message);
            setShowErrorMessage(true);
          }
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(() => {});
    }
  };

  return (
    <>
      <Card style={{ width: '100%' }}>
        <Card.Body>
          <Form onSubmit={handleSubmit(onSubmit)}>
            <Row>
              <Col>
                <Form.Group className="mb-2">
                  <Form.Label>Calle</Form.Label>
                  <FormControl
                    {...register('calle', {
                      required: 'Campo Requerido'
                    })}
                    type="text"
                    defaultValue={customer?.calle}
                    isInvalid={!!errors.calle}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.calle?.message}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group className="mb-4">
                  <Form.Label>No Interior</Form.Label>
                  <FormControl
                    {...register('noint', {
                      required: 'Campo Requerido'
                    })}
                    type="text"
                    defaultValue={customer?.noint}
                    isInvalid={!!errors.noint}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.noint?.message}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-4">
                  <Form.Label>No Exterior</Form.Label>
                  <FormControl
                    {...register('noext', {
                      required: 'Campo Requerido'
                    })}
                    type="text"
                    defaultValue={customer?.noext}
                    isInvalid={!!errors.noext}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.noext?.message}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group className="mb-4">
                  <Form.Label>Colonia</Form.Label>
                  <FormControl
                    {...register('colonia', {
                      required: 'Campo Requerido'
                    })}
                    type="text"
                    defaultValue={customer?.colonia}
                    isInvalid={!!errors.colonia}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.colonia?.message}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group className="mb-4">
                  <Form.Label>Estado</Form.Label>
                  <select
                    aria-label="Default select"
                    name="idestado"
                    id="idestado"
                    className="form-control"
                    {...register('estado', {
                      required: 'Campo Requerido'
                    })}
                    onChange={e => {
                      setValue('estado', e.target.value, {
                        shouldValidate: true
                      });
                      setSelectedEstado(e.target.value);
                      getMunicipiosList(e.target.value);
                    }}
                    value={`${selectedEstado}`}
                    style={{ minWidth: '250px' }}
                  >
                    <option key={'location_0'} value="">
                      Selecciona un estado
                    </option>
                    {!!states?.length &&
                      states.map(estado => (
                        <option key={estado.idestado} value={estado.idestado}>
                          {estado.descripcion}
                        </option>
                      ))}
                  </select>
                  <Form.Control.Feedback type="invalid">
                    {errors.estado?.message}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                {municipios && (
                  <AutocompleteDropdown
                    items={
                      !municipios
                        ? []
                        : municipios.map(municipio => {
                            return {
                              id: municipio.idmunicipio,
                              description: municipio.descripcion
                            };
                          })
                    }
                    placeholder="Selecciona un municipio"
                    register={register}
                    errors={errors}
                    name="idmunicipio"
                    currentSelected={selectedMunicipioDescription}
                    setCurrentSelected={value => {
                      console.log(value);

                      getCpsList(value.id);
                      setValue('idmunicipio', value.id, {
                        shouldValidate: true
                      });
                    }}
                    setValue={setValue}
                  />
                )}
              </Col>
            </Row>
            <Row>
              <Col>
                {cps && (
                  <AutocompleteDropdown
                    items={
                      !cps
                        ? []
                        : cps.map(cp => {
                            return {
                              id: cp.idcodigopostal,
                              description: cp.codigopostal
                            };
                          })
                    }
                    placeholder="Selecciona un Codigo Postal"
                    register={register}
                    errors={errors}
                    name="idcodigopostal"
                    currentSelected={selectedCodigoPostalDescription}
                    setCurrentSelected={value => {
                      setValue('idcodigopostal', value, {
                        shouldValidate: true
                      });
                    }}
                    setValue={setValue}
                  />
                )}
              </Col>
            </Row>
            <Row>
              <Col>
                <Button type="submit" color="primary" size="sm">
                  Guardar
                </Button>
              </Col>
            </Row>
          </Form>
        </Card.Body>
      </Card>

      <NotificationAlert
        message={errorMesagge}
        showNotification={showErrorMessage}
        setShowNotification={setShowErrorMessage}
        isError={isError}
      />
    </>
  );
};
EditAdress.propTypes = {
  idAddress: PropTypes.number.isRequired,
  idCustomer: PropTypes.number.isRequired,
  closeModal: PropTypes.func.isRequired
};
export default EditAdress;
